import { css } from '@emotion/react';
import { theme } from '../../../design-system/theme/theme';

/*
 * 세로/가로 스크롤을 이 박스 안에서 처리 — 가로 스크롤바가 뷰포트 안(박스 하단)에
 * 위치해, 페이지 맨 아래까지 내리지 않아도 닿는다. 머리글은 sticky로 고정.
 */
export const scrollStyle = css`
  overflow: auto;
  max-height: calc(100vh - 260px);

  table {
    white-space: nowrap;
  }

  thead {
    position: sticky;
    top: 0;
    z-index: 1;
  }
`;

/* 주석이 있는 머리글 — hover 시 title 툴팁이 뜨는 점선 밑줄 힌트. */
export const headerTipStyle = css`
  cursor: help;
  border-bottom: 1px dotted currentColor;
`;

export const rowStyle = (selected: boolean) => css`
  cursor: pointer;
  background: ${selected ? theme.color.primarySoft : 'transparent'};

  &:hover {
    background: ${theme.color.primarySoft};
  }
`;

/* 셀 최대 16rem — 시안 max-w-[16rem] truncate. */
export const cellStyle = css`
  max-width: 16rem;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: ${theme.fontSize.sm}px;
`;
